<template>
  <div class="benchmark-size">
    <div>
      <span class="benchmark-size__title">Benchmark Classification:</span>
      <span class="benchmark-size__label label label-info"
            data-type="tooltip"
            data-title="X Large = 20+ Physicians | Large = 11 - 20 Physicians | Medium = 5 – 10 Physicians | Small = 1 – 4 Physicians">{{ practiceBenchmark }}</span>
    </div>
    <div class="benchmark-size__subtitle">(can change from month-to-month)</div>
  </div>
</template>

<script>
  export default {
    name: 'Benchmarks',
    props: ['practiceBenchmark'],
  };
</script>
